// Frames at about 30 a second. The runtime's actions and its drawing share this clock, so both
// slow down together; actions are timed by the clock, not counted in frames, so every move still
// takes as long as it should. A 60 Hz screen gives every other frame, 120 Hz every fourth.
export function frameClock(fps = 30) {
  const step = 1000 / fps - 4;                   // a little slack for frames that come early
  const handles = new Map();
  let serial = 0, last = -Infinity;
  return {
    now: () => performance.now(),
    requestFrame(callback) {
      const id = ++serial;
      const next = time => {
        if (time - last < step) { handles.set(id, requestAnimationFrame(next)); return; }
        last = time; handles.delete(id);
        callback(time);
      };
      handles.set(id, requestAnimationFrame(next));
      return id;
    },
    cancelFrame(id) {
      if (handles.has(id)) cancelAnimationFrame(handles.get(id));
      handles.delete(id);
    },
  };
}
